export default () =>  $('[data-select-text]').on('click',function(){ this.select(); });
